export default __webpack_public_path__ + "static/new-tsh__core-360-paid-02-a4a800875365aa4b24189e8d7383eb9a.jpg";